module.exports = __webpack_public_path__ + "static/fipcbiglovemain-b3b9e2d8694baff14873e6744a4103ff.jpeg";